<template>
	<ListPage :query="query" :total="total" v-loading="loading" :data="tableData" @size-change="handleSizeChange"
		@current-change="handleCurrentChange" @search="handleSearch" @reset="resetQuery">
		<template slot="filters">
			<el-form-item label="邮箱地址" prop="word">
				<el-input v-model="query.word" placeholder="请输入邮箱地址" clearable @keyup.enter.native="handleSearch" />
			</el-form-item>
			<el-form-item label="产品" prop="productId">
				<Product :multiple="false" v-model="query.productId" placeholder="请选择产品" />
			</el-form-item>
			<el-form-item label="电池" prop="batteryId">
				<Battery v-model="query.batteryId" placeholder="请选择电池" />
			</el-form-item>
		</template>
		<template slot="btns">
			<el-button icon="el-icon-download" size="mini" type="primary" @click="handleExport">
				导出数据
			</el-button>
		</template>
		<template slot="columns">
			<el-table-column label="接收邮箱" align="center" prop="emailAddress" />
			<el-table-column label="电源设备" align="center" prop="productName" />
			<el-table-column label="电池型号" align="center" prop="batteryName" />
			<el-table-column label="发送时间" align="center" prop="createTime">
				<template slot-scope="{ row }">
					{{ formatDate(row.createTime) }}
				</template>
			</el-table-column>
			<el-table-column label="操作" align="center" width="140">
				<template slot-scope="{ row }">
					<el-link :underline="false" type="primary" @click="handleView(row)">
						查看
					</el-link>
				</template>
			</el-table-column>
		</template>
	</ListPage>
</template>

<script>
import { page, excel } from "@/api/email";
import listMixin from '@/mixins/list';
import utils from "@/jslibs/utils";
import Product from "@/components/Product";
import Battery from "@/components/Battery";

export default {
	components: { Product, Battery },
	data() {
		return {
			// 查询参数
			query: {
				word: "",
				status: undefined
			},
			ids: []
		};
	},
	mixins: [listMixin],
	methods: {
		search() {
			this.loading = true;
			const params = {
				...this.query,
			};
			page(params).then(({ code, data, message }) => {
				if (code == 200) {
					this.tableData = data.records;
					this.total = data.total;
				} else {
					this.$message.error(message);
				}
				this.loading = false;
			});
		},
		handleExport() {
			excel(this.query).then(res => {
				const blob = new Blob([res]);
				const fileName = `邮件列表.xls`;
				utils.downloadBlobFile(blob, fileName);
			});
		},
		handleView(row) {
			this.$router.push({ path: "/email/detail", query: { id: row.id } });
		}
	},
};
</script>